import React from "react";
import { Icon } from "semantic-ui-react";

const consultationTypeSchema = function(state, props) {
  const iconSelection =
    [ // 1️⃣ Human-oriented
    'talk', 'user', 'user outline', 'users', 'hand point up', 'hand paper', 'handshake', 'handshake outline', 'thumbs up',
    'child', 'male', 'female', 'street view', 'venus mars', 'smile outline', 'meh outline', 'frown outline', 'comment',
    'comment outline', 'comment alternate', 'comment alternate outline', 'comments', 'comments outline', 'address card',

    // 2️⃣ Abstract / symbolic
    'heart', 'star', 'star outline', 'check circle', 'times circle', 'ellipsis horizontal', 'exclamation', 'info circle',
    'quote right', 'clock', 'hourglass', 'history', 'sync', 'sitemap', 'balance scale', 'puzzle', 'euro sign',
    'lightbulb outline', 'gem', 'medkit', 'eye', 'paint brush', 'cloud', 'sun', 'tree', 'umbrella',

    // 3️⃣ Objects / tangible items
    'phone', 'home', 'calendar', 'certificate', 'coffee', 'music', 'pencil alternate', 'bullhorn', 'desktop', 'anchor',
    'binoculars', 'bomb', 'flask', 'key', 'leaf', 'magnet', 'map pin', 'map signs', 'paw', 'suitcase', 'tag', 'tags',
    'wrench', 'weight', 'bicycle', 'bookmark', 'cube', 'cubes', 'archive', 'book',  'flag', 'trophy', 'life ring']

  return {
    "ui:order": ["name", "icon" , "duration", "*"],
    "name": {
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:options": {
        width: 4
      }
    },
    "icon": {
      "ui:widget": "select",
      "ui:options": {
        width: 1,
        selectOptions: iconSelection.map( (icon) => {
          return { key: icon, value: icon, text: <Icon name={icon} />  }
        })
      }
    },
    "duration": {
      "ui:widget": "TimeDurationWidget",
      "ui:options": {
        width: 2
      }
    },
    "officeId": {
      "ui:widget": 'hidden',
    },
  }
}

export default consultationTypeSchema;
